export var UsUtField;
(function (UsUtField) {
    UsUtField["VERSION"] = "Version";
    UsUtField["SHARING_NOTICE"] = "SharingNotice";
    UsUtField["SALE_OPT_OUT_NOTICE"] = "SaleOptOutNotice";
    UsUtField["TARGETED_ADVERTISING_OPT_OUT_NOTICE"] = "TargetedAdvertisingOptOutNotice";
    UsUtField["SENSITIVE_DATA_PROCESSING_OPT_OUT_NOTICE"] = "SensitiveDataProcessingOptOutNotice";
    UsUtField["SALE_OPT_OUT"] = "SaleOptOut";
    UsUtField["TARGETED_ADVERTISING_OPT_OUT"] = "TargetedAdvertisingOptOut";
    UsUtField["SENSITIVE_DATA_PROCESSING"] = "SensitiveDataProcessing";
    UsUtField["KNOWN_CHILD_SENSITIVE_DATA_CONSENTS"] = "KnownChildSensitiveDataConsents";
    UsUtField["MSPA_COVERED_TRANSACTION"] = "MspaCoveredTransaction";
    UsUtField["MSPA_OPT_OUT_OPTION_MODE"] = "MspaOptOutOptionMode";
    UsUtField["MSPA_SERVICE_PROVIDER_MODE"] = "MspaServiceProviderMode";
})(UsUtField || (UsUtField = {}));
export const USUT_CORE_SEGMENT_FIELD_NAMES = [
    UsUtField.VERSION,
    UsUtField.SHARING_NOTICE,
    UsUtField.SALE_OPT_OUT_NOTICE,
    UsUtField.TARGETED_ADVERTISING_OPT_OUT_NOTICE,
    UsUtField.SENSITIVE_DATA_PROCESSING_OPT_OUT_NOTICE,
    UsUtField.SALE_OPT_OUT,
    UsUtField.TARGETED_ADVERTISING_OPT_OUT,
    UsUtField.SENSITIVE_DATA_PROCESSING,
    UsUtField.KNOWN_CHILD_SENSITIVE_DATA_CONSENTS,
    UsUtField.MSPA_COVERED_TRANSACTION,
    UsUtField.MSPA_OPT_OUT_OPTION_MODE,
    UsUtField.MSPA_SERVICE_PROVIDER_MODE,
];
